// utils/getLogoUrl.js
import { buildS3Url } from 'utils/s3Utils';

export const getFundInitial = (fund) => {
    const name =
        fund?.fundName ??
        fund?.morningStarName ??
        fund?.schemeName ??
        fund?.name ??
        fund?.bankName ??
        fund?.displayName ??
        "";

    return name?.trim?.() ? name.trim().charAt(0).toUpperCase() : "F";
};

export const getLogoUrl = (fund) => {
    const logo = fund?.amcLogo ?? fund?.logo ?? fund?.fundLogo ?? null;
    return logo ? buildS3Url(logo) : null;
};

/**
 * First initial of a bank name, used as the fallback when no logo is available.
 * @param {Object|string} bank - Bank/account object or bank name
 * @returns {string} Single uppercase letter, "B" when the name is missing
 */
export const getBankInitial = (bank) => {
    const name = typeof bank === "string"
        ? bank
        : bank?.bankName ?? bank?.bank_name ?? bank?.name ?? "";

    return name?.trim?.() ? name.trim().charAt(0).toUpperCase() : "B";
};

/**
 * Resolve the S3 URL for a bank logo.
 * @param {Object|string} bank - Bank/account object or raw logo path
 * @returns {string|null} Full S3 URL, or null when there is no logo to show
 */
export const getBankLogoUrl = (bank) => {
    const logo = typeof bank === "string"
        ? bank
        : bank?.bankLogo ?? bank?.bank_logo ?? bank?.logo ?? null;

    if (!logo || typeof logo !== "string") return null;

    try {
        return buildS3Url(logo) ?? null;
    } catch {
        return null;
    }
};
